module.exports = __webpack_public_path__ + "static/media/home.60be3d6a.svg";